import { Dispatch } from 'vuex';
import reports from '@/store/reports/reports';

export default {
	namespaced: true,
	modules: { reports },
	actions: {
		cleanAllReports({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('reports/cleanAllReports');
		},
	},
};
